module.exports = __webpack_public_path__ + "img/3.a646650c.png";